
const _ = require('lodash');
const ko = require('knockout');
const $ = require('rgs-jquery');
require('rgs-bootstrap');

if (typeof window !== 'undefined') { // browser
	require('jquery-inputcapitalize');
	require('rgs-jquery-fileupload');
}

require('./bindings/index.js');

ko.bindingHandlers.unapplyBindings = {
	/* Allows descendant bindings.
	 *
	 * Useful as a workaround for
	 * > You cannot apply bindings multiple times to the same element.
	 * error.
	 */
	init: function () {
		return { controlsDescendantBindings: true };
	},
};
ko.virtualElements.allowedBindings.unapplyBindings = true;

ko.bindingHandlers.let = {
	/*
	 * Adds new properties to the context (scope).
	 *
	 * Copypasted from http://knockoutjs.com/documentation/custom-bindings-controlling-descendant-bindings.html#example-supplying-additional-values-to-descendant-bindings
	 * where it's called `withProperties'
	 */
	init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
		// Make a modified binding context, with a extra properties, and apply it to descendant elements
		const innerBindingContext = bindingContext.extend(valueAccessor);
		ko.applyBindingsToDescendants(innerBindingContext, element);

		// Also tell KO *not* to bind the descendants itself, otherwise they will be bound twice
		return { controlsDescendantBindings: true };
	},
};
ko.virtualElements.allowedBindings.let = true;

// Bootstrap Touchspin
ko.bindingHandlers.bsTouchspin = {
	init: function (element, valueAccessor) {
		function getOptions () {
			return valueAccessor() || {};
		}
		const $element = $(element);
		const options = getOptions();
		$element.TouchSpin(options);

		ko.computed(function () {
			const options = getOptions();
			$element.trigger('touchspin.updatesettings', options);
		}, null, { disposeWhenNodeIsRemoved: element });
	},
};

//Bootstrap fileupload
ko.bindingHandlers.bsFileupload = {
	init: function (element, valueAccessor){
		function getOptions (){
			return _.extend({
				url: '/api/file/SaveTemporaryFile',
				forceIframeTransport: true,
				dataType: 'json',
				formAcceptCharset: 'utf-8',
			}, valueAccessor());
		}
		const $element = $(element);

		ko.computed(function (){
			const options = getOptions();
			$element.fileupload(options);

			if (options.guaranteeAddHack) {
				$element.fileupload('add', {
					files: [''],
				});
			}

		}, null, { disposeWhenNodeIsRemoved: element });
	},
};

ko.bindingHandlers.bsToggle = {
	init: function (element, valueAccessor, allBindings) {
		function getOptions () {
			return valueAccessor() || {};
		}
		const $element = $(element);
		const options = getOptions();

		$element.bootstrapToggle(options);

		// TODO: 'enable'bindings integration

		if (allBindings.has('disable')) {
			ko.computed(() => {
				const isDisabled = ko.unwrap(allBindings.get('disable'));
				if (isDisabled) {
					$element.parent().addClass('toggle-disabled');
				} else {
					$element.parent().removeClass('toggle-disabled');
				}
			}, null, { disposeWhenNodeIsRemoved: element });
		}

		if (allBindings.has('checked')) {
			const updateFromModel = function () {
				const newValue = Boolean(ko.unwrap(allBindings.get('checked')));
				const elementValue = Boolean($element.prop('checked'));

				const valueHasChanged = (newValue !== elementValue);

				if (valueHasChanged) {
					$element.bootstrapToggle(newValue ? 'on' : 'off');
				}
			};

			ko.computed(updateFromModel, null, { disposeWhenNodeIsRemoved: element });

			$element.on('change', function () {
				const observable = allBindings.get('checked');
				const elementValue = Boolean($element.prop('checked'));
				const modelValue = Boolean(observable.peek());

				const valueHasChanged = (modelValue !== elementValue);

				if (ko.isWritableObservable(observable) && valueHasChanged) {
					observable(elementValue);
				}
			});
		}
	},
};

ko.bindingHandlers.jqInputcapitalize = {
	update: function (element, valueAccessor) {
		const options = valueAccessor();
		
		if (options) {
			const $element = $(element);
			$element.inputcapitalize(options);
		}
	},
};

// Sets jQuery data ($(...).data(key, value)) on an element for each key-value
// pair in the value object
ko.bindingHandlers.jqData = {
	init: function (element, valueAccessor) {
		const $element = $(element);
		ko.computed(function () {
			const value = ko.unwrap(valueAccessor());
			$.each(value, function (k, v) {
				$element.data(k, ko.unwrap(v));
			});
		}, null, { disposeWhenNodeIsRemoved: element });
	},
};

// Bind events with `jQuery.fn.on` with deligation support.
// Example: `jqOn: { click: { 'a[href]': function () {} } }`
ko.bindingHandlers.jqOn = {
	init: function (element, valueAccessor) {
		const $element = $(element);

		const events = valueAccessor();

		_.each(events, function (handlers, event) {
			if (_.isFunction(handlers)) {
				// from `jqOn: { click: function() {} }`
				// to `jqOn: { click: { '*': function () {} } }`
				handlers = { '*': handlers };
			}
			_.each(handlers, function (handler, selector) {
				$element.on(event, selector, handler);
			});
		});
	},
};

// makes element follow the state (hover/active/focus) of a child
ko.bindingHandlers.followChildState = (function () {
	const STATES = {
		focus: {
			'in': 'focusin',
			'out': 'focusout',
		},
		hover: {
			'in': 'mousein',
			'out': 'mouseout',
		},
	};

	const EVENTS = _.reduce(STATES, function (events, inOut, state) {
		events[inOut.in] = {
			state: state,
			value: true,
		};
		events[inOut.out] = {
			state: state,
			value: false,
		};
		return events;
	}, {});

	return {
		init: function (element, valueAccessor) {
			const $element = $(element);
			let options = ko.unwrap(valueAccessor());

			if (_.isArray(options)) {
				options = { states: options };
			}

			options = _.defaults({}, options, {
				states: ['focus'],
				selector: 'input',
			});

			const events = _(STATES)
				.pick(options.states)
				.map(function (v) {
					return [v.in, v.out];
				})
				.flatten()
				.value();

			$element.on(events.join(' '), options.selector, function (e) {
				const st = EVENTS[e.type];
				$element.toggleClass(st.state, st.value);
			});
		},
	};
}());

//
ko.bindingHandlers.isHover = {
	init: function (element, valueAccessor) {
		$(element).on('mouseenter.ko.bindings mouseleave.ko.bindings', function (e) {
			const fn = valueAccessor();
			if (_.isFunction(fn)) {
				fn(e.type === 'mouseenter');
			}
		});
	},
};
